import './Breadcrumbs-99078f17.css';

var classes = {"BreadcrumbsBase":"prc-Breadcrumbs-BreadcrumbsBase-6gqOz","BreadcrumbsList":"prc-Breadcrumbs-BreadcrumbsList-K7eeK","ItemWrapper":"prc-Breadcrumbs-ItemWrapper-Mfwuj","Item":"prc-Breadcrumbs-Item-7BKO-","ItemSelected":"prc-Breadcrumbs-ItemSelected-9ZYcW"};

export { classes as default };
